export default "__VITE_ASSET__D_PBAe6$__"